import FileItem from './FileItem-redux';

export default FileItem;
